import { TasksTestID } from "@/constants/TestID";
import TaskBasicDetails from "@/ui/components/tasks/TaskBasicDetails";
import { VStack } from "@/ui/layout";

const baseTestID = TasksTestID.MedicalEvaluationTaskDetails;

interface MedicalEvaluationTaskDetailsProps {
  description: string;
  duration: string;
  patientName?: string;
  title: string;
}

const MedicalEvaluationTask = ({
  description,
  duration,
  patientName,
  title,
}: MedicalEvaluationTaskDetailsProps) => {
  return (
    <VStack gap={24}>
      <TaskBasicDetails
        description={description}
        duration={duration}
        patientName={patientName}
        testID={baseTestID}
        title={title}
      />
    </VStack>
  );
};

export default MedicalEvaluationTask;
